import ResponsiveTitle from '@/components/molecules/responsiveTitle'
import Container from '@/components/templates/container'
import Banner from './banner'
import Content from './content'

const Facilites = ({ title, banner, content }) => {
  return (
    <Container outerClassName="my-largeMobile lg:my-largeDesktop">
      <ResponsiveTitle
        left={title.left}
        center={title.center}
        right={title.right}
        size="medium"
      />
      <Banner desktop={banner.desktop} mobile={banner.mobile} />
      <Content
        imageSmall={content.imageSmall}
        imageBig={content.imageBig}
        description={content.description}
        leftCtaButton={content.leftCtaButton}
        rightCtaButton={content.rightCtaButton}
      />
    </Container>
  )
}

export default Facilites
